// ============================================================================================
// LE NOM D'UN APPAREIL, À L'ÉCRAN — « Chalet 5 caisse 1 », ou « Sans nom ».
//
// UTILITÉ : le nom est ce qui dit à un humain quelle machine il a devant lui. Tous les écrans qui citent un appareil
// (parc, fiche magasin, assistant, locations, blocages, recherche) le disent de la même façon, depuis ce module.
// ⚠️ UN APPAREIL SANS NOM SE DIT « Sans nom », JAMAIS UN AUTRE CHAMP À SA PLACE (cadrage de la Console) : afficher le
//    modèle ou la série dans la case du nom ferait passer pour un nom choisi ce qui n'en est pas un, et cacherait les
//    appareils qu'il reste à nommer. Le nom est exigé à l'ajout et à la modification ; seuls les appareils entrés au
//    parc avant lui en manquent.
// ============================================================================================

/** Ce que dit la case du nom d'un appareil qui n'en a pas. */
export const UNNAMED = 'Sans nom';

/** Le nom d'un appareil tel qu'une liste le montre. */
export function deviceTitle(d: { name: string | null }): string {
  return d.name ?? UNNAMED;
}

/**
 * L'appareil désigné dans une PHRASE (toast, titre de confirmation, option d'une liste) : son nom, à défaut son type et
 * sa série. ⚠️ Ici le repli est légitime : la phrase doit dire DE QUEL appareil elle parle, pas remplir la case du nom.
 */
export function deviceRef(d: { name: string | null; family: string; serial?: string | null }): string {
  return d.name ?? `${d.family}${d.serial ? ` ${d.serial}` : ''}`;
}

/** Le nom d'un appareil, rendu : « Sans nom » en gris italique, pour qu'il se distingue d'un nom choisi. */
export function DeviceName({ d }: { d: { name: string | null } }) {
  return d.name
    ? <>{d.name}</>
    : <span data-unnamed style={{ fontStyle: 'italic', fontWeight: 500, color: 'var(--ink400)' }}>{UNNAMED}</span>;
}
